import React from 'react';

import { SideNavigation } from '@amzn/awsui-components-react';

const header = {
  "href": "/",
  "text": "Secure AI Sandbox"
}

const items = [
  { type: "link", text: "Home", href: "/" },
  { type: "link", text: "My Sandboxes", href: "/sandboxes" },
  { type: "link", text: "Create Instance", href: "/create" },
  { type: "link", text: "Update Instance", href: "/update" }
];

function SideBar(props) {
    return (
        <SideNavigation activeHref={props.activeHref} header={header} items={items}></SideNavigation>
    );
}

export default SideBar;
